import React, { useEffect, useState } from "react";
import congrats from "../../Assets/svg/congrats.svg";
import { useSelector } from "react-redux";
import Button from "./Button";
import avatar from "../../Assets/svg/avatar-img.svg";
import notify from "../../Assets/svg/notification icon.svg";
import edit from "../../Assets/svg/edit icon2.svg";

function CongratsInfo(props) {
  const idInfo = useSelector((state) => state.tokens.tokens);
  const [Link, setLink] = useState("");
  const registeredData = useSelector((state) => state.register.registeredData);

  const personalInfo = useSelector((state) => state.personal.personalInfo);

  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
  }, []);
  return (
    <div className=" content congrats content-item">
      {/* <div className="content-left "> */}
      <div
        className="progress-title form-title"
        // style={{ color: "#C4C4C4" }}
      >
        {" "}
        Welcome, {personalInfo?.firstName ?? ""}
      </div>
      <div className=" reward-msg">
        <div className="congrats-icon">
          <img src={congrats} alt="congrats" />
        </div>
        <div className="congrats-texts">
          <div className="form-title">Congratulations! </div>
          <div className="set-title">
            The IDFC FIRST Bank{" "}
            {registeredData?.info?.course?.includes("ENGINEERING")|| registeredData?.info?.course?.includes("Engineering") || idInfo?.applicationData?.eduInfo?.degreeType === "B.Tech" || idInfo?.applicationData?.eduInfo?.degreeType === "B.E."
              ? "Engineering"
              : "MBA"}{" "}
            Scholarship has been awarded to you !
          </div>
          {/* <div className="set-title">
        For next steps, please check the email you have received from us.

        </div> */}
          {/* {Link.split("/")[2] === "submitted-status" && ( */}
          <div className="item-id">
            Application ID:{" "}
            <span>{idInfo.applicationData.salesforceStudentAppNumber}</span>
          </div>
          {/* )} */}
        </div>
      </div>
    </div>
  );
}

export default CongratsInfo;
